import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row g-3" }
const _hoisted_2 = { class: "row col-md-6" }
const _hoisted_3 = { class: "el-input-group" }
const _hoisted_4 = { class: "col-md-9" }
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = { class: "row col-md-6" }
const _hoisted_7 = { class: "el-input-group" }
const _hoisted_8 = { class: "col-md-9" }
const _hoisted_9 = { class: "input-group" }
const _hoisted_10 = { class: "row col-md-6" }
const _hoisted_11 = { class: "el-input-group" }
const _hoisted_12 = { class: "col-md-9" }
const _hoisted_13 = { class: "input-group" }
const _hoisted_14 = { class: "row col-md-6" }
const _hoisted_15 = { class: "el-input-group" }
const _hoisted_16 = { class: "col-md-9" }
const _hoisted_17 = { class: "input-group" }
const _hoisted_18 = { class: "row col-md-6" }
const _hoisted_19 = { class: "el-input-group" }
const _hoisted_20 = { class: "col-md-9" }
const _hoisted_21 = { class: "input-group" }
const _hoisted_22 = { class: "row col-md-6" }
const _hoisted_23 = { class: "el-input-group" }
const _hoisted_24 = { class: "col-md-9" }
const _hoisted_25 = { class: "input-group" }
const _hoisted_26 = { class: "col-md-7" }
const _hoisted_27 = { class: "el-input-group" }
const _hoisted_28 = {
  key: 1,
  class: "btn btn-loading",
  disabled: ""
}
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-md-4" }
const _hoisted_31 = { class: "col-md-4" }
const _hoisted_32 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "mb-12" }
const _hoisted_35 = { class: "container py-5." }
const _hoisted_36 = { style: {"width":"100%","padding-bottom":"5px"} }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-auto" }
const _hoisted_39 = { class: "col-auto" }
const _hoisted_40 = { class: "col-auto" }
const _hoisted_41 = { class: "col-auto" }
const _hoisted_42 = { class: "messaging" }
const _hoisted_43 = { class: "inbox_msg" }
const _hoisted_44 = { class: "mesgs" }
const _hoisted_45 = { class: "msg_history" }
const _hoisted_46 = {
  key: 0,
  style: {"text-align":"center","padding-top":"10px","font-size":"14px","cursor":"pointer","text-decoration":"underline"}
}
const _hoisted_47 = {
  key: 0,
  class: "incoming_msg_img"
}
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "time_date" }
const _hoisted_50 = { style: {"float":"right","margin-right":"5px"} }
const _hoisted_51 = {
  key: 0,
  class: "type_msg"
}
const _hoisted_52 = { class: "input_msg_write" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = ["disabled"]
const _hoisted_55 = ["disabled"]
const _hoisted_56 = { class: "selected-file-item" }
const _hoisted_57 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiselect = _resolveComponent("multiselect")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_vue_loading = _resolveComponent("vue-loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _cache[35] || (_cache[35] = _createElementVNode("h2", null, "Уведомление", -1)),
      _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[26] || (_cache[26] = _createElementVNode("label", {
              for: "bin",
              class: "form-label col-md-3"
            }, "БИН", -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "bin",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchParams.bin) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.searchParams.bin]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[27] || (_cache[27] = _createElementVNode("label", {
              for: "katoCode",
              class: "form-label col-md-3"
            }, "Населенный пункт", -1)),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_multiselect, {
                  modelValue: _ctx.kato,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.kato) = $event)),
                  options: _ctx.katoList,
                  searchable: true,
                  closeOnSelect: true,
                  "track-by": "code",
                  "custom-label": _ctx.formattedKatoLabel,
                  placeholder: "Выберите Като",
                  multiple: false,
                  "clear-on-select": true
                }, null, 8, ["modelValue", "options", "custom-label"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[28] || (_cache[28] = _createElementVNode("label", {
              for: "bin",
              class: "form-label col-md-3"
            }, "Наименование", -1)),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "bin",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchParams.name) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.searchParams.name]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _cache[29] || (_cache[29] = _createElementVNode("label", {
              for: "bin",
              class: "form-label col-md-3"
            }, "Исполнитель", -1)),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "bin",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchParams.executor) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.searchParams.executor]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _cache[31] || (_cache[31] = _createElementVNode("label", {
              for: "bin",
              class: "form-label col-md-3"
            }, "Финансирование", -1)),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchParams.fundingStatus) = $event)),
                  id: "fundingStatus",
                  class: "form-control"
                }, _cache[30] || (_cache[30] = [
                  _createElementVNode("option", { value: null }, "Все статусы", -1),
                  _createElementVNode("option", { value: "IN_PROGRESS" }, "Осуществляется", -1),
                  _createElementVNode("option", { value: "SUSPENDED" }, "Приостановлено", -1)
                ]), 512), [
                  [_vModelSelect, _ctx.searchParams.fundingStatus]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _cache[33] || (_cache[33] = _createElementVNode("label", {
              for: "signStatus",
              class: "form-label col-md-3"
            }, "По статусу", -1)),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchParams.lastMessageStatus) = $event)),
                  id: "notificationStatus",
                  class: "form-control"
                }, _cache[32] || (_cache[32] = [
                  _createElementVNode("option", { value: null }, "Все статусы", -1),
                  _createElementVNode("option", { value: "SENT" }, "Отправлено", -1),
                  _createElementVNode("option", { value: "DELIVERED" }, "Доставлено", -1)
                ]), 512), [
                  [_vModelSelect, _ctx.searchParams.lastMessageStatus]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.fetchReports(true)))
            }, "Поиск"),
            _createElementVNode("button", {
              class: "btn btn-warning",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clearSearchParam()))
            }, "Сбросить фильтр"),
            (!_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-info",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.downloadGeneratedCalculationReportList()))
                }, "Выгрузить результат по фильтру"))
              : (_openBlock(), _createElementBlock("button", _hoisted_28, "Загрузка"))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_b_pagination, {
            modelValue: _ctx.currentPage,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.currentPage) = $event)),
            "total-rows": _ctx.pageResponse?.totalElements,
            "per-page": _ctx.searchParams.pageSize
          }, null, 8, ["modelValue", "total-rows", "per-page"])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _cache[34] || (_cache[34] = _createElementVNode("span", null, "Элементов в странице: ", -1)),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["btn btn-secondary", {'active': _ctx.searchParams.pageSize == 10}]),
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changePageElementSize(10)))
            }, "10", 2),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["btn btn-secondary", {'active': _ctx.searchParams.pageSize == 50}]),
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changePageElementSize(50)))
            }, "50", 2),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["btn btn-secondary", {'active': _ctx.searchParams.pageSize == 100}]),
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.changePageElementSize(100)))
            }, "100", 2)
          ])
        ])
      ]),
      _createVNode(_component_el_table, {
        data: _ctx.items,
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "#",
            width: "50"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.searchParams.pageSize * _ctx.searchParams.page + scope.$index + 1), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "БИН" }, {
            default: _withCtx((scope) => [
              _createElementVNode("a", {
                onClick: ($event: any) => (_ctx.openNotificationModal(scope.row)),
                href: "#"
              }, _toDisplayString(scope.row.bin), 9, _hoisted_33)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "Название ДО" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.kindergartenName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "LMS ID" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.lmsId), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "Населенный пункт" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.getKatoNameRu(scope.row.katoCode)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "Адрес" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.address), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "Статус" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.getLastMessageStatusText(scope.row.lastMessageStatus)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "Финансирование" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.getFundingStatusText(scope.row.fundingStatus)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "Исполнитель" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.fundingStatusSuspendedByUser), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createVNode(_component_b_modal, {
      modelValue: _ctx.showModal,
      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.showModal) = $event)),
      title: _ctx.messageModalTitle,
      size: "xl"
    }, {
      footer: _withCtx(() => [
        (_ctx.isEditable && _ctx.lmsSystemNotificationDto?.notificationStatus != 'OPEN')
          ? (_openBlock(), _createBlock(_component_b_button, {
              key: 0,
              variant: "primary",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.startNotification(true)))
            }, {
              default: _withCtx(() => _cache[42] || (_cache[42] = [
                _createTextVNode("Начать диалог")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isEditable && _ctx.lmsSystemNotificationDto?.notificationStatus == 'OPEN')
          ? (_openBlock(), _createBlock(_component_b_button, {
              key: 1,
              variant: "danger",
              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.startNotification(false)))
            }, {
              default: _withCtx(() => _cache[43] || (_cache[43] = [
                _createTextVNode("Прекратить")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isEditable && _ctx.lmsSystemNotificationDto?.fundingStatus == 'IN_PROGRESS')
          ? (_openBlock(), _createBlock(_component_b_button, {
              key: 2,
              variant: "danger",
              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.startLmsSystemFunding(false)))
            }, {
              default: _withCtx(() => _cache[44] || (_cache[44] = [
                _createTextVNode("Прекратить финансирования")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isEditable && _ctx.lmsSystemNotificationDto?.fundingStatus != 'IN_PROGRESS')
          ? (_openBlock(), _createBlock(_component_b_button, {
              key: 3,
              variant: "success",
              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.startLmsSystemFunding(true)))
            }, {
              default: _withCtx(() => _cache[45] || (_cache[45] = [
                _createTextVNode("Снять со стоп листа")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_b_button, {
          variant: "secondary",
          onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.showModal = false))
        }, {
          default: _withCtx(() => _cache[46] || (_cache[46] = [
            _createTextVNode("Закрыть")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("form", _hoisted_34, [
          _createElementVNode("section", null, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _cache[37] || (_cache[37] = _createElementVNode("b", { class: "padding-r-5px" }, "Населенный пункт:", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.getKatoNameRu(_ctx.lmsSystemNotificationDto?.katoCode)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _cache[38] || (_cache[38] = _createElementVNode("b", { class: "padding-r-5px" }, "Адрес:", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.lmsSystemNotificationDto?.address), 1)
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _cache[39] || (_cache[39] = _createElementVNode("b", { class: "padding-r-5px" }, "Финансирование:", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.getFundingStatusText(_ctx.lmsSystemNotificationDto?.fundingStatus)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _cache[40] || (_cache[40] = _createElementVNode("b", { class: "padding-r-5px" }, "Контакты:", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.lmsSystemNotificationDto?.directorPhone), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      (_ctx.messages.length && _ctx.messages[0]?.totalRowCounts > _ctx.messages.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                            _createElementVNode("a", {
                              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.loadOldMessages && _ctx.loadOldMessages(...args)))
                            }, "<<Загрузить старые сообщение >>")
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(item.sendByManager ? 'outgoing_msg' : 'incoming_msg')
                        }, [
                          (!item.sendByManager)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, _cache[41] || (_cache[41] = [
                                _createElementVNode("img", {
                                  src: "https://ptetutorials.com/images/user-profile.png",
                                  alt: "sunil"
                                }, null, -1)
                              ])))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", {
                            class: _normalizeClass(item.sendByManager ? 'sent_msg' : 'received_msg')
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(item.sendByManager ? '' : 'received_withd_msg')
                            }, [
                              _createElementVNode("p", null, _toDisplayString(item.message), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.fileDtos, (file) => {
                                return (_openBlock(), _createElementBlock("div", null, [
                                  _createElementVNode("a", {
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.downloadFile(file)),
                                    style: {"font-size":"10px"}
                                  }, _toDisplayString(file.fileName) + " (" + _toDisplayString((file.size / 1024).toFixed(2)) + "Kb)", 9, _hoisted_48)
                                ]))
                              }), 256)),
                              _createElementVNode("span", _hoisted_49, [
                                _createTextVNode(_toDisplayString(item.createdAt) + " | " + _toDisplayString(item.createdByFullName) + " ", 1),
                                _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.getLastMessageStatusText(item.status)), 1)
                              ])
                            ], 2)
                          ], 2)
                        ], 2))
                      }), 256))
                    ]),
                    (_ctx.isEditable)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.messageDto) = $event)),
                              disabled: _ctx.lmsSystemNotificationDto?.notificationStatus != 'OPEN',
                              class: "write_msg",
                              onKeyup: _cache[15] || (_cache[15] = _withKeys(($event: any) => (_ctx.messageDto.trim() && _ctx.sendMessage()), ["enter"])),
                              onKeypress: _cache[16] || (_cache[16] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                              placeholder: "Введите текст сообщение"
                            }, null, 40, _hoisted_53), [
                              [_vModelText, _ctx.messageDto]
                            ]),
                            _createElementVNode("button", {
                              class: "msg_send_btn",
                              type: "button",
                              disabled: _ctx.lmsSystemNotificationDto?.notificationStatus != 'OPEN',
                              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.sendMessage()))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-paper-plane'] })
                            ], 8, _hoisted_54),
                            _createElementVNode("button", {
                              class: "upload_send_btn",
                              type: "button",
                              disabled: _ctx.lmsSystemNotificationDto?.notificationStatus != 'OPEN',
                              onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.triggerFileInput && _ctx.triggerFileInput(...args)))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-upload'] })
                            ], 8, _hoisted_55),
                            _createElementVNode("input", {
                              type: "file",
                              id: "fileUpload",
                              ref: "fileInput",
                              onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
                              multiple: "",
                              style: {"display":"none"},
                              accept: ".pdf, .doc, .docx, .xls, .xlsx",
                              class: "form-control"
                            }, null, 544)
                          ]),
                          _createElementVNode("div", _hoisted_56, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageSelectedFiles, (file, index) => {
                              return (_openBlock(), _createElementBlock("span", { key: index }, [
                                _createTextVNode(_toDisplayString(index + 1) + ") " + _toDisplayString(file.name) + " ", 1),
                                _createElementVNode("a", {
                                  onClick: ($event: any) => (_ctx.removeFile(index))
                                }, "❌", 8, _hoisted_57)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_vue_loading, {
      active: _ctx.isLoading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}